import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { meInstoreOnlyOffer as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    isLoaderInverted: false,
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
